let _ = t => t,
  _t;
import { createGlobalStyle } from 'styled-components';
import { Text } from 'foundations-components/components/Text';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIModal from 'UIComponents/dialog/UIModal';
import Confetti from 'growth-onboarding-confetti/Confetti';
import OnboardingTourButtons from '../OnboardingTourButtons';
import { useTourContext, useIsLastStep } from '../../../js/hooks/tour';

// Hide the banner from modals and show it only after the user action on the modal CTA.
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HandholdingBannerGlobalStyle = createGlobalStyle(_t || (_t = _`
.uiFullScreenBackground #onboarding-tours-banner-frame {
  filter: blur(5px);
  z-index: auto !important
  }
  `));
const OnboardingTourModal = props => {
  const {
    step: {
      title,
      text,
      actionText,
      buttons,
      modal
    },
    onCloseComplete,
    onOpenStart,
    rootNode,
    'data-test-step-index': dataTestStepIndex
  } = props;
  const modalProps = modal !== undefined && typeof modal !== 'boolean' ? modal : {};
  const {
    showConfetti
  } = modalProps;
  const {
    tour
  } = useTourContext();
  const isOnLastStep = useIsLastStep();
  return /*#__PURE__*/_jsxs(UIModal, {
    "data-test-step-index": dataTestStepIndex,
    onCloseComplete: onCloseComplete,
    onOpenStart: onOpenStart,
    rootNode: rootNode,
    use: "conversational",
    width: 550,
    children: [showConfetti && /*#__PURE__*/_jsx(Confetti, {
      widthPercentage: 300
    }), /*#__PURE__*/_jsxs(UIDialogHeader, {
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h3",
        textAlign: "start",
        children: title
      }), isOnLastStep && /*#__PURE__*/_jsx(UIDialogCloseButton, {
        "data-test-id": "onboarding-tour-modal-close-button",
        onClick: () => {
          tour.finish();
        }
      })]
    }), /*#__PURE__*/_jsxs(UIDialogBody, {
      children: [/*#__PURE__*/_jsx(Text, {
        marginBlockStart: "600",
        textAlign: "start",
        children: text
      }), actionText && /*#__PURE__*/_jsx(Text, {
        marginBlockStart: "400",
        textAlign: "start",
        children: /*#__PURE__*/_jsx("strong", {
          children: actionText
        })
      })]
    }), /*#__PURE__*/_jsx(UIDialogFooter, {
      children: /*#__PURE__*/_jsx(OnboardingTourButtons, {
        buttons: buttons || []
      })
    }), /*#__PURE__*/_jsx(HandholdingBannerGlobalStyle, {})]
  });
};
export default OnboardingTourModal;